import { render } from "./BaseSeparator.vue?vue&type=template&id=d6e1fabc"
import script from "./BaseSeparator.vue?vue&type=script&lang=js"
export * from "./BaseSeparator.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/user-web-app/user-web-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__